var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-calendar',{ref:"calendar",attrs:{"color":"primary","type":"day","first-time":"08:00","interval-count":"15","interval-width":"90","mode":"stack","locale":"fr","events":_vm.orderedplanning},on:{"click:time":_vm.setTimeDay},model:{value:(_vm.cal),callback:function ($$v) {_vm.cal=$$v},expression:"cal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }